export default "__VITE_ASSET__B7QaGPY1__"